export type PageView = {
  page_location: string
  page_referrer: string
  page_title: string
}

declare global {
  interface Window {
    dataLayer?: unknown[]
  }
}

/** Never forward query strings/fragments (OAuth tokens, phone numbers, search inputs). */
function cleanUrl(value: string) {
  try {
    const url = new URL(value)
    return /^https?:$/.test(url.protocol) ? `${url.origin}${url.pathname}` : ''
  } catch {
    return ''
  }
}

function pageTitle(pathname: string) {
  // Static titles avoid collecting user-provided group names and mount-effect timing.
  if (pathname.startsWith('/detail-group/')) return 'Kelola Grup · LioJastip'
  const titles: Record<string, string> = {
    '/': 'LioJastip',
    '/login': 'Masuk · LioJastip',
    '/groups': 'Dashboard · LioJastip',
    '/onboard': 'Hubungkan Grup · LioJastip',
  }
  return titles[pathname] ?? 'LioJastip'
}

export function initialPageView(): PageView {
  return {
    page_location: cleanUrl(window.location.href),
    page_referrer: cleanUrl(document.referrer),
    page_title: 'LioJastip',
  }
}

export function createPageTracker(send: (page: PageView) => void) {
  let previousLocation = ''
  let referrer = cleanUrl(document.referrer)

  return (pathname: string) => {
    const location = cleanUrl(`${window.location.origin}${pathname}`)
    if (!location || previousLocation === location) return
    send({
      page_location: location,
      page_referrer: referrer,
      page_title: pageTitle(new URL(location).pathname),
    })
    previousLocation = location
    referrer = location
  }
}
